/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

import Types from '../../../modules/types';

const {
  CONTENT_BUILDER_EFFECT: { TYPE_MAP: CBEF_MAP },
} = Types;

const isNotFilter = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'FILTER',
]);

CBEF_MAP.FILTER.children.filter_items.TYPE_ITEMS.forEach((item) => {
  isNotFilter[item.id] = Admin.compileFromLibrary([
    'condition.testFieldValue',
    'type',
    '!==',
    item.id,
  ]);
});

const ITEM_FIELDS = Admin.compileFromLibrary([
  ['FieldHidden', {
    name: 'type',
  }],
  ...CBEF_MAP.FILTER.children.filter_items.TYPE_ITEMS.map(
    item => getFilterWithCol(['FieldText', {
      label: null,
      name: `${item.id.toLowerCase()}_value`,
      prefix: 'Value:',
      addonAfter: item.addonAfter,
      type: 'number',
      align: 'right',
      skip: [isNotFilter[item.id]],
    }], 24),
  ),
], true);

Admin.addToLibrary(
  'FieldContentBuilderEffects:FILTER:ITEM',
  (config = {}) => Admin.compileFromLibrary(['FieldContentBuilderNodes', {
    name: 'filter_items',
    preSkip: [isNotFilter],
    addButtonChoices: CBEF_MAP.FILTER.children.filter_items.TYPE_ITEMS,
    addButtonLabel: 'Add Filter',
    pasteButtonLabel: 'Paste Filter',
    toolbarProps: {
      items: CBEF_MAP.FILTER.children.filter_items.TYPE_ITEMS,
      itemsLabelsMap: CBEF_MAP.FILTER.children.filter_items.TYPE_LABELS_MAP,
    },
    copyRealm: 'ContentBuilder:Effect:FILTER:filter_items',
    pasteRealm: 'ContentBuilder:Effect:FILTER:filter_items:*',
    targetable: false,
    fields: [
      ...ITEM_FIELDS,
    ],
    nodeType: CBEF_MAP.FILTER.children.filter_items.node,
    ...config,
  }]),
);

export default [
  ...[
    getFilterWithCol(['FieldRadio', {
      label: null,
      name: 'filter_type',
      choices: ['Normal', 'Backdrop'].map(label => ({
        label,
        value: label.toUpperCase(),
      })),
      block: true,
    }], 24),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotFilter, ...(fieldConfig.preSkip || [])],
    },
  ])),
  ['FieldContentBuilderEffects:FILTER:ITEM', {
    name: 'filter_items',
  }],
];
